import http from "../http-common";

class HardwareTicketDataService {
    getAll(offsetValue, sortBy, sortOrder, user_id_asking) {
        return http.get(`/hardwareTickets?offset=${offsetValue}&sortBy=${sortBy}&sortOrder=${sortOrder}&userIdAsking=${user_id_asking}`, { withCredentials: true });
    }

    getAttachments(id) {
        return http.get(`/hardwareTickets/${id}/getAttachments`, { withCredentials: true });
    }

    getUnresolvedTicketCount() {
        return http.get(`/hardwareTickets/unresolvedCount`, { withCredentials: true });
    }

    getTicketHistory(id, timezoneAdjustmentFactor) {
        return http.get(`/hardwareTickets/${id}/history?timezoneAdjustmentFactor=${timezoneAdjustmentFactor}`, { withCredentials: true });
    }

    filterByCategory(categoryID, offsetValue, sortBy, sortOrder, user_id_asking) {
        return http.get(`/hardwareTickets?categoryID=${categoryID}&offset=${offsetValue}&sortBy=${sortBy}&sortOrder=${sortOrder}&userIdAsking=${user_id_asking}`, { withCredentials: true });
    }

    filterByCategoryAndSearchText(categoryName, offsetValue, searchText, sortBy, sortOrder, user_id_asking) {
        return http.get(`/hardwareTickets?categoryName=${categoryName}&searchText=${searchText}&offset=${offsetValue}&sortBy=${sortBy}&sortOrder=${sortOrder}&userIdAsking=${user_id_asking}`, { withCredentials: true });
    }

    createHardwareTicket(data) {
        return http.post("/hardwareTickets", data, { withCredentials: true, headers: { 'Content-Type': `multipart/form-data` } });
    }

    get(id, timezoneAdjustmentFactor) {
        return http.get(`/hardwareTickets/${id}?timezoneAdjustmentFactor=${timezoneAdjustmentFactor}`, { withCredentials: true });
    }

    getComments(id, timezoneAdjustmentFactor) {
        return http.get(`/hardwareTickets/${id}/comments?timezoneAdjustmentFactor=${timezoneAdjustmentFactor}`, { withCredentials: true });
    }

    getLikesDislikes(id, uid) {
        return http.get(`/hardwareTickets/${id}/likesdislikes?uid=${uid}`, { withCredentials: true });
    }

    getBoolIndividualHardwareTicketEmails(id, uid, globalHardwareEmailStatus) {
        return http.get(`/hardwareTickets/${id}/getIndividualHardwareEmailStatus?uid=${uid}&globalHardwareEmailStatus=${globalHardwareEmailStatus}`, { withCredentials: true });
    }

    getAssignableParentTickets(user_id_asking, searchText) {
        return http.get(`/hardwareTickets/parentTickets/getAssignable?userIdAsking=${user_id_asking}&searchText=${searchText}`, { withCredentials: true });
    }

    changeIndividualHardwareTicketEmailStatus(id, uid, data) {
        return http.put(`/hardwareTickets/${id}/updateIndividualHardwareTicketEmailStatus?uid=${uid}`, data, { withCredentials: true });
    }

    addLike(id, uid) {
        return http.get(`/hardwareTickets/${id}/like?uid=${uid}`, { withCredentials: true });
    }

    addDislike(id, uid) {
        return http.get(`/hardwareTickets/${id}/dislike?uid=${uid}`, { withCredentials: true });
    }

    createHardwareTicketComment(data) {
        return http.post("/hardwareTickets/comments", data, { withCredentials: true });
    }

    createHardwareTicketTechNote(data) {
        return http.post("/hardwareTickets/techNotes", data, { withCredentials: true });
    }

    addSolution(id, data) {
        return http.put(`/hardwareTickets/${id}/addSolution`, data, { withCredentials: true });
    }

    removeSolution(id, data) {
        return http.put(`/hardwareTickets/${id}/removeSolution`, data, { withCredentials: true });
    }

    getNewTicketFormData(id, askerId) {
        return http.get(`/hardwareTickets/${id}/newTicketFormData?askerId=${askerId}`, { withCredentials: true });
    }

    editHardwareTicket(id, data) {
        return http.put(`/hardwareTickets/${id}/editHardwareTicket`, data, { withCredentials: true });
    }

    findByText(searchText, offsetValue, sortBy, sortOrder, user_id_asking) {
        return http.get(`/hardwareTickets?searchText=${searchText}&offset=${offsetValue}&sortBy=${sortBy}&sortOrder=${sortOrder}&userIdAsking=${user_id_asking}`, { withCredentials: true });
    }

    findRelatedTickets(titleText, user_id_asking) {
        return http.get(`/hardwareTickets/all/relatedTickets?titleText=${titleText}&userIdAsking=${user_id_asking}`, { withCredentials: true });
    }

    updateTechAssignment(id, data) {
        return http.put(`/hardwareTickets/${id}/updateTechAssignment`, data, { withCredentials: true });
    }

    getSlas() {
        return http.get('/hardwareTickets/slas/all', { withCredentials: true });
    }

    getTimespanTickets(tenant_id, timespan, timespanType, timespanAssignedTo, userIdAsking, timezoneAdjustmentFactor) {
        let timespanToUse = [];
        if(timespan && timespan.length > 1 && timespan[0] !== null && timespan[0] !== "") {
            timespanToUse[0] = timespan[0].toISOString().split('T')[0] + " 00:00:00";
        }
        if(timespan && timespan.length > 1 && timespan[1] !== null && timespan[1] !== "") {
            timespanToUse[1] = timespan[1].toISOString().split('T')[0] + " 23:59:59";
        }
        let assignedToString = timespanAssignedTo.length === 0 ? "0" : timespanAssignedTo.join(", ");
        return http.get(`/hardwareTickets/reports/timespanTickets?tenantId=${tenant_id}&timespan=${timespanToUse}&timespanType=${timespanType}&timespanAssignedTo=${assignedToString}&userIdAsking=${userIdAsking}&timezoneAdjustmentFactor=${timezoneAdjustmentFactor}`, { withCredentials: true });
    }

    getOverdueTickets(tenant_id, timespan, timespanType, timespanAssignedTo, userIdAsking, timezoneAdjustmentFactor) {
        let timespanToUse = [];
        if(timespan && timespan.length > 1 && timespan[0] !== null && timespan[0] !== "") {
            timespanToUse[0] = timespan[0].toISOString().split('T')[0] + " 00:00:00";
        }   
        if(timespan && timespan.length > 1 && timespan[1] !== null && timespan[1] !== "") {
            timespanToUse[1] = timespan[1].toISOString().split('T')[0] + " 23:59:59";
        }
        let assignedToString = timespanAssignedTo.length === 0 ? "0" : timespanAssignedTo.join(", ");
        return http.get(`/hardwareTickets/reports/overdueTickets?tenantId=${tenant_id}&timespan=${timespanToUse}&timespanType=${timespanType}&timespanAssignedTo=${assignedToString}&userIdAsking=${userIdAsking}&timezoneAdjustmentFactor=${timezoneAdjustmentFactor}`, { withCredentials: true });
    }

    getResolvedTickets(tenant_id, timespan, timespanType, timespanAssignedTo, userIdAsking, timezoneAdjustmentFactor) {
        let timespanToUse = [];
        if(timespan && timespan.length > 1 && timespan[0] !== null && timespan[0] !== "") {
            timespanToUse[0] = timespan[0].toISOString().split('T')[0] + " 00:00:00";
        }
        if(timespan && timespan.length > 1 && timespan[1] !== null && timespan[1] !== "") {
            timespanToUse[1] = timespan[1].toISOString().split('T')[0] + " 23:59:59";
        }
        let assignedToString = timespanAssignedTo.length === 0 ? "0" : timespanAssignedTo.join(", ");
        return http.get(`/hardwareTickets/reports/resolvedTickets?tenantId=${tenant_id}&timespan=${timespanToUse}&timespanType=${timespanType}&timespanAssignedTo=${assignedToString}&userIdAsking=${userIdAsking}&timezoneAdjustmentFactor=${timezoneAdjustmentFactor}`, { withCredentials: true });
    }

    getWarningTickets(tenant_id, timespan, timespanType, timespanAssignedTo, userIdAsking, timezoneAdjustmentFactor) {
        let timespanToUse = [];
    try{
        if(timespan && timespan.length > 1 && timespan[0] !== null && timespan[0] !== "") {
            timespanToUse[0] = timespan[0].toISOString().split('T')[0] + " 00:00:00";
        }
        if(timespan && timespan.length > 1 && timespan[1] !== null && timespan[1] !== "") {
            timespanToUse[1] = timespan[1].toISOString().split('T')[0] + " 23:59:59";
        }
        let assignedToString = timespanAssignedTo.length === 0 ? "0" : timespanAssignedTo.join(", ");
        return http.get(`/hardwareTickets/reports/warningTickets?tenantId=${tenant_id}&timespan=${timespanToUse}&timespanType=${timespanType}&timespanAssignedTo=${assignedToString}&userIdAsking=${userIdAsking}&timezoneAdjustmentFactor=${timezoneAdjustmentFactor}`, { withCredentials: true });
    }
    catch{
        console.log("bruh failed badly")
        return null
    }
    }

    getOverdueTicketsRegularTechNotificationCenter(tenant_id, userIdAsking, timezoneAdjustmentFactor) {
        return http.get(`/hardwareTickets/reports/getOverdueTicketsRegularTechNotificationCenter?tenantId=${tenant_id}&userIdAsking=${userIdAsking}&timezoneAdjustmentFactor=${timezoneAdjustmentFactor}`, { withCredentials: true });
    }

    getWarningTicketsRegularTechNotificationCenter(tenant_id, userIdAsking, timezoneAdjustmentFactor) {
        return http.get(`/hardwareTickets/reports/getWarningTicketsRegularTechNotificationCenter?tenantId=${tenant_id}&userIdAsking=${userIdAsking}&timezoneAdjustmentFactor=${timezoneAdjustmentFactor}`, { withCredentials: true });
    }

    changeAssignedParent(ticket_id, data) {
        return http.put(`/hardwareTickets/${ticket_id}/changeAssignedParent`, data, { withCredentials: true });
    }

    allowToBeParent(ticket_id, data) {
        return http.put(`/hardwareTickets/${ticket_id}/allowToBeParent`, data, { withCredentials: true });
    }

    removeAbilityToBeParent(ticket_id, data) {
        return http.put(`/hardwareTickets/${ticket_id}/removeAbilityToBeParent`, data, { withCredentials: true });
    }

    getNumberOfTicketsLast24Hours(tenant_id, userIdAsking) {
        return http.get(`/hardwareTickets/widget/getNumberOfTicketsLast24Hours?tenantId=${tenant_id}&userIdAsking=${userIdAsking}`, { withCredentials: true });
    }

    getNumberOfTicketsLastWeek(tenant_id, userIdAsking) {
        return http.get(`/hardwareTickets/widget/getNumberOfTicketsLastWeek?tenantId=${tenant_id}&userIdAsking=${userIdAsking}`, { withCredentials: true });
    }

    getOnHoldReasons(tenant_id) {
        return http.get(`/hardwareTickets/onHold/getReasons?tenantId=${tenant_id}`, { withCredentials: true });
    }

    changeOnHoldStatus(data, ticket_id, ticket_type, requester_id, new_status, reason) {
        return http.put(`/hardwareTickets/onHold/changeHoldStatus?ticketId=${ticket_id}&ticketType=${ticket_type}&requesterId=${requester_id}&newStatus=${new_status}&reason=${reason}`, data, { withCredentials: true });
    }

    updateCCList(data, ticket_id) {
        return http.put(`/hardwareTickets/${ticket_id}/updateCCList`, data, { withCredentials: true });
    }

    submitSatisfactionSurvey(data) {
        return http.post(`/submitSatisfactionSurvey`, data);
    }

    getSpecificSurveyDetails(ticket_id) {
        return http.get(`/hardwareTickets/reports/specificSurveyDetails?ticketId=${ticket_id}`, { withCredentials: true });
    }
}

export default new HardwareTicketDataService();